export default "__VITE_ASSET__CNWTpm_a__"